import { TransactionType } from "@/types/enums/TransactionType";
import { TMessageKey } from "@/i18n/types.gen";
import { Transaction } from "@/types/Transactions";
import { compact } from "lodash";

export enum IssuedBy {
  BOARD_MEETING = "boardMeetingPoA",
  GENERAL_MEETING = "generalMeeting",
}

export const issuedByLabels: { [key in IssuedBy]: TMessageKey } = {
  [IssuedBy.BOARD_MEETING]: "transactions.issueTransaction.boardMeetingPoA",
  [IssuedBy.GENERAL_MEETING]: "transactions.issueTransaction.generalMeeting",
};

export const ALL_SHARES = "ALL_SHARES_IN_THE_COMPANY";

export const transactionTypeItemsEmptyState: TransactionType[] = [
  TransactionType.INCORPORATION,
  TransactionType.SHAREHOLDING_PER_DATE,
];

export const transactionTypeItems: TransactionType[] = compact([
  TransactionType.BUY_SELL,
  TransactionType.ISSUE,
  TransactionType.PAY_DIVIDEND,
  TransactionType.GROUP_CONTRIBUTION,
  TransactionType.INCREASE_NOMINAL_VALUE,
  TransactionType.INHERITANCE,
  TransactionType.GIFT,
  TransactionType.CANCELLATION_OF_SHARES,
  TransactionType.REDUCTION_NOMINAL_VALUE,
  TransactionType.SPLIT,
  TransactionType.REVERSE_SPLIT,
  TransactionType.CONVERSION_OF_SHARES,
  TransactionType.CONVERSION_FROM_ISIN,
  TransactionType.LIQUIDATION,
  TransactionType.MERGER,
  TransactionType.OTHER_TRANSFER,
  TransactionType.DEMERGER,
]);

export function isInitialTransactionType(type: TransactionType): boolean {
  return [
    TransactionType.INCORPORATION,
    TransactionType.SHAREHOLDING_PER_DATE,
    TransactionType.AUTOIMPORT,
  ].includes(type);
}

export function maxDateForTransaction(transaction: Transaction, allTransactions: Transaction[]) {
  return isInitialTransactionType(transaction.transactionType) && allTransactions.length > 1
    ? allTransactions[1].transactionDate
    : "";
}

export function minDateForTransaction(transaction: Transaction, allTransactions: Transaction[]) {
  switch (transaction.transactionType) {
    case "INCORPORATION":
    case "AUTOIMPORT":
    case "SHAREHOLDING_PER_DATE":
    case "OWNERS_PER_DATE":
    case "COMPANY_STATUS_CHANGE":
      return "";
    case "LIQUIDATION":
      return allTransactions[allTransactions.length - 2].transactionDate;
    default:
      return allTransactions[0].transactionDate;
  }
}

export function canDeleteTransaction(
  transaction: Transaction,
  numberOfTransactions: number,
): boolean {
  return numberOfTransactions === 1 || !isInitialTransactionType(transaction.transactionType);
}
